/* WR FLY-TO-CART v2 — choreographed add-to-cart feedback.
   Sequence: lift-off (clone rises & casts shadow) -> curved bezier
   flight (clone shrinks into a rounded "bead") -> cart catch
   (squash & stretch) + brand-purple ripple ring + badge pop.
   Pure visual sugar: never blocks the submit, transform/opacity only,
   respects prefers-reduced-motion. */
(function () {
  'use strict';
  if (window.__wrFlyToCart) return;
  window.__wrFlyToCart = true;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var BRAND = '#472d6b';
  var FLIGHT_MS = 820;
  var LIFT_MS = 150;

  function cartIcon() {
    return (
      document.querySelector('header a[href*="/cart"]') ||
      document.querySelector('a[href*="/cart"]')
    );
  }

  function sourceImage(form) {
    var scope =
      form.closest('.wr-compare-card') ||
      form.closest('product-info') ||
      form.closest('.shopify-section') ||
      document;
    var candidates = scope.querySelectorAll(
      '.product-gallery img, [class*="gallery"] img, .wr-compare-card__media img, .product-card img, img'
    );
    for (var i = 0; i < candidates.length; i++) {
      var im = candidates[i];
      var r = im.getBoundingClientRect();
      if (r.width > 40 && r.height > 40 && im.src) return im;
    }
    return null;
  }

  /* Quadratic bezier between centers, arched upward; n keyframes. */
  function pathKeyframes(from, to, n, scaleEnd, rotEnd) {
    var x0 = 0, y0 = 0;
    var x2 = to.cx - from.cx, y2 = to.cy - from.cy;
    /* control point: midway, lifted ~0.35 of distance (min 90px, max 220px) */
    var lift = Math.max(90, Math.min(220, Math.hypot(x2, y2) * 0.35));
    var x1 = x2 * 0.5, y1 = Math.min(y0, y2) * 0.5 - lift;
    var frames = [];
    for (var i = 0; i <= n; i++) {
      var t = i / n;
      var mt = 1 - t;
      var x = mt * mt * x0 + 2 * mt * t * x1 + t * t * x2;
      var y = mt * mt * y0 + 2 * mt * t * y1 + t * t * y2;
      /* shrink late (easeIn) so the product stays readable mid-flight */
      var s = 1 - (1 - scaleEnd) * (t * t * (3 - 2 * t));
      var rot = rotEnd * t;
      frames.push({
        transform: 'translate(' + x + 'px,' + y + 'px) scale(' + s + ') rotate(' + rot + 'deg)',
        opacity: t > 0.85 ? String(1 - (t - 0.85) / 0.15 * 0.65) : '1',
        offset: t
      });
    }
    return frames;
  }

  function makeClone(img, rect) {
    var wrap = document.createElement('div');
    wrap.style.cssText =
      'position:fixed;z-index:99999;pointer-events:none;margin:0;' +
      'left:' + rect.left + 'px;top:' + rect.top + 'px;' +
      'width:' + rect.width + 'px;height:' + rect.height + 'px;' +
      'will-change:transform,opacity;';
    var inner = img.cloneNode(false);
    inner.removeAttribute('srcset');
    inner.removeAttribute('sizes');
    inner.style.cssText =
      'width:100%;height:100%;object-fit:contain;border-radius:10px;' +
      'filter:drop-shadow(0 6px 14px rgba(26,24,24,.22));' +
      'transition:border-radius ' + FLIGHT_MS + 'ms ease;will-change:filter;';
    wrap.appendChild(inner);
    document.body.appendChild(wrap);
    return { wrap: wrap, inner: inner };
  }

  function ripple(target) {
    var r = target.getBoundingClientRect();
    var ring = document.createElement('span');
    var size = Math.max(r.width, r.height) + 8;
    ring.style.cssText =
      'position:fixed;z-index:99998;pointer-events:none;border-radius:50%;' +
      'left:' + (r.left + r.width / 2 - size / 2) + 'px;' +
      'top:' + (r.top + r.height / 2 - size / 2) + 'px;' +
      'width:' + size + 'px;height:' + size + 'px;' +
      'border:2px solid ' + BRAND + ';opacity:.8;';
    document.body.appendChild(ring);
    ring.animate(
      [
        { transform: 'scale(.6)', opacity: 0.8 },
        { transform: 'scale(2.4)', opacity: 0 }
      ],
      { duration: 620, easing: 'cubic-bezier(.22,.61,.36,1)' }
    ).onfinish = function () { ring.remove(); };
  }

  function catchBounce(target) {
    target.animate(
      [
        { transform: 'scale(1)' },
        { transform: 'scale(.86) rotate(-3deg)', offset: 0.3 },
        { transform: 'scale(1.18) rotate(2deg)', offset: 0.62 },
        { transform: 'scale(.96)', offset: 0.85 },
        { transform: 'scale(1)' }
      ],
      { duration: 480, easing: 'cubic-bezier(.34,1.56,.64,1)' }
    );
    /* badge pop: bubble next to the cart icon, if the theme renders one */
    var badge = target.querySelector('[class*="count"], [class*="bubble"], [data-cart-count]');
    if (badge) {
      badge.animate(
        [
          { transform: 'scale(1)', background: '' },
          { transform: 'scale(1.6)', offset: 0.4 },
          { transform: 'scale(1)' }
        ],
        { duration: 420, easing: 'cubic-bezier(.34,1.56,.64,1)', delay: 60 }
      );
    }
  }

  function fly(img, target) {
    var fromR = img.getBoundingClientRect();
    var toR = target.getBoundingClientRect();
    var from = { cx: fromR.left + fromR.width / 2, cy: fromR.top + fromR.height / 2 };
    var to = { cx: toR.left + toR.width / 2, cy: toR.top + toR.height / 2 };
    var scaleEnd = Math.max(0.07, Math.min(34 / fromR.width, 34 / fromR.height));

    var lead = makeClone(img, fromR);

    /* 1) lift-off: slight rise + grow, shadow deepens (picking the product up) */
    var lift = lead.wrap.animate(
      [
        { transform: 'translateY(0) scale(1)' },
        { transform: 'translateY(-10px) scale(1.05)' }
      ],
      { duration: LIFT_MS, easing: 'ease-out', fill: 'forwards' }
    );

    lift.onfinish = function () {
      /* 2) flight: curved path; the bead rounds off mid-air */
      lead.inner.style.borderRadius = '50%';
      var frames = pathKeyframes(from, to, 28, scaleEnd, 6);
      lead.wrap.animate(frames, {
        duration: FLIGHT_MS,
        easing: 'cubic-bezier(.45,.05,.35,1)',
        fill: 'forwards'
      }).onfinish = function () {
        lead.wrap.remove();
        /* 3) arrival choreography */
        catchBounce(target);
        ripple(target);
      };
    };

    /* safety net: never leave clones behind */
    setTimeout(function () {
      if (lead.wrap.parentNode) lead.wrap.remove();
    }, LIFT_MS + FLIGHT_MS + 600);
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.getAttribute) return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;
      var target = cartIcon();
      var img = sourceImage(form);
      if (target && img) {
        try {
          fly(img, target);
        } catch (err) {
          /* visual sugar only — never break the purchase */
        }
      }
    },
    true
  );
})();
